import './index.scss';
import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';
import ClassNames from 'classnames';

class Toggleable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }
  static displayName = 'Toggleable';

  static propTypes = {
    handler: PropTypes.node.isRequired,
    content: PropTypes.node.isRequired,
  };

  static defaultProps = (function () {
    expanded: false;
  })();

  _toggleArea = () => {
    $(this.refs.toggleable).transition('fade', 100);
    this.setState({ expanded: !this.state.expanded });
  };

  classNames = () => {
    return ClassNames('Toggleable', {
      expanded: this.props.expanded,
    });
  };

  render() {
    return (
      <div className={this.classNames()}>
        <div
          className="Toggleable-Handler"
          aria-expanded={this.state.expanded}
          onClick={this._toggleArea}
        >
          {this.props.handler}
        </div>
        <div className="Toggleable-Content" ref="toggleable">
          {this.props.content}
        </div>
      </div>
    );
  }
}

export default Toggleable;
